module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/菌落仪图片日文.b33d555d.png";